import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { Text2Bold } from 'components/typography/Texts';
import { useAccountClosingPopup } from 'hooks/useAccountClosingPopup';

const Text = styled(Text2Bold)`
  cursor: pointer;
  margin-top: 24px;
  color: ${theme.color.red};
`;

export const AccountClosing = () => {
  const { t } = useTranslation('myProfile');
  const { showAccountClosingPopup } = useAccountClosingPopup();

  return (
    <Text data-testid={'account-closing'} onClick={showAccountClosingPopup}>
      {t('account-settings.account-closing')}
    </Text>
  );
};
